import React from 'react';
import Grid from 'styled-components-grid';
import styled from 'styled-components'
import {Margin, py} from 'styled-components-spacing'
import Link from 'gatsby-link'
import {FullImage} from '../components/Styles'

const RelativeLink = styled(Link)`
  position: relative;
  display: block;
  border-radius: 10px;
  box-shadow: 0 2px 10px 4px rgba(0,0,0,.6);
  overflow: hidden;
  img {
    transition: opacity .1s linear;
  }
  div {
    transition: background .1s linear;
  }
  &:hover {
    img {
      opacity: .8;
    }
    div {
      background: linear-gradient(to left, rgba(255,255,255,.5), rgba(255,255,255,.9), rgba(255,255,255,.5));
    }
  }
`;
const Name = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  background: linear-gradient(to left, rgba(255,255,255,.1), rgba(255,255,255,.8), rgba(255,255,255,.1));
  left: 0;
  text-align: center;
  ${py(2)};
  color: black;
`;

const ImageLink = (props) => (
  <Grid.Unit size={1/3}>
    <Margin horizontal={2}>
      <RelativeLink to={props.to}>
        <FullImage src={props.image} alt={props.alt || 'airfly - parapenthe lien image'} />
        <Name>{props.name}</Name>
      </RelativeLink>
    </Margin>
  </Grid.Unit>
);

export default ImageLink;


// WEBPACK FOOTER //
// ./src/components/ImageLink.js